import * as React from "react";
import { IPublicPlan, buildPackageRegistrationUrl } from "../../libs";

interface IProps {
  plan: IPublicPlan;
  registrationContext?: {
    userId?: string;
    name?: string;
    email?: string;
  };
  preview?: boolean;
  actionLabel?: string;
  actionDisabled?: boolean;
  onAction?: () => void;
}

export const PublicPlanCard: React.FC<IProps> = ({
  plan,
  registrationContext,
  preview = false,
  actionLabel,
  actionDisabled = false,
  onAction,
}) => {
  const packageItem = plan.package;
  const contactParams = new URLSearchParams({
    packageId: packageItem.id,
    plan: packageItem.name,
  });
  const href =
    plan.action === "CONTACT"
      ? `/contact?${contactParams.toString()}`
      : buildPackageRegistrationUrl(packageItem.id, registrationContext);
  const buttonLabel =
    actionLabel || (plan.action === "CONTACT" ? "Contact Us" : `Start with ${packageItem.name}`);
  const isDisabled = preview || actionDisabled;

  return (
    <div className={`card package-card${plan.highlighted ? " popular" : ""}`}>
      {plan.highlighted && (
        <div className="popular-choice text-center text-uppercase">
          <span>Most Popular</span>
        </div>
      )}
      <div className="card-body">
        <h2 className="card-title">{packageItem.name}</h2>
        <p className="card-text mb-4 mb-md-5">{packageItem.description}</p>
        <h3 className="price mb-4 mb-md-5">
          {Number(packageItem.monthlyPrice) > 0 ? (
            <>
              ${Number(packageItem.monthlyPrice).toFixed(2)}
              <span>/month</span>
            </>
          ) : (
            "Custom"
          )}
        </h3>
        <ul className="notes">
          {packageItem.features.map((feature) => (
            <li key={feature}>{feature}</li>
          ))}
        </ul>
      </div>
      <div className="card-footer d-grid">
        {onAction ? (
          <button
            type="button"
            className="btn btn-primary"
            disabled={isDisabled}
            onClick={onAction}
          >
            {buttonLabel}
          </button>
        ) : (
          <a
            href={href}
            className={`btn btn-primary${isDisabled ? " disabled" : ""}`}
            onClick={isDisabled ? (event) => event.preventDefault() : undefined}
            aria-disabled={isDisabled || undefined}
            tabIndex={isDisabled ? -1 : undefined}
          >
            {buttonLabel}
          </a>
        )}
      </div>
    </div>
  );
};
